import "./AboutPage.css";

export default function AboutPage() {
    return (
        <div className="about-container">

            <section className="hero-section">
                <h1 className="hero-title">About Interview Buster</h1>
                <p className="hero-subtitle">
                    Your personal platform for **real interview-style practice**, designed to help developers
                    clear interviews with confidence.
                </p>
            </section>

            <section className="about-section">
                <h2 className="section-title">What is Interview Buster?</h2>
                <p className="section-text">
                    Interview Buster is a next-generation interview preparation platform built for serious
                    learners who want to practice **real interview questions**, not generic theory.
                </p>
                <p className="section-text">
                    Companies ask practical questions, expect structured answers, and want strong reasoning.
                    This is exactly what we train you for.
                </p>
            </section>

            <section className="features-section">
                <h2 className="section-title">Why Developers Love Us</h2>

                <div className="feature-grid">

                    <div className="feature-card">
                        <h3>🔥 Real Company Questions</h3>
                        <p>
                            All questions come from real interview experiences shared by real candidates —
                            so you practice exactly what companies ask.
                        </p>
                    </div>

                    <div className="feature-card">
                        <h3>🧠 Full Explanation</h3>
                        <p>
                            Every question includes a beautifully structured explanation so you understand
                            what a perfect answer looks like.
                        </p>
                    </div>

                    <div className="feature-card">
                        <h3>🎧 Voice or Text Answer</h3>
                        <p>
                            Practice by typing or speaking — just like a real interview round with an
                            interviewer.
                        </p>
                    </div>

                    <div className="feature-card">
                        <h3>📚 Domain-wise Preparation</h3>
                        <p>
                            Select your domain and experience level to get **targeted** interview tests made
                            specifically for your niche.
                        </p>
                    </div>

                    <div className="feature-card">
                        <h3>🧪 Interview-Style Tests</h3>
                        <p>
                            Each pack includes 10 interview tests that simulate a real hiring round step by
                            step.
                        </p>
                    </div>

                    <div className="feature-card">
                        <h3>🚀 Confidence Booster</h3>
                        <p>
                            Practice improves performance. After 2–3 packs, your hesitation reduces and your
                            answer quality improves drastically.
                        </p>
                    </div>

                </div>
            </section>

            <section className="mission-section">
                <h2 className="section-title">Our Mission</h2>
                <p className="section-text">
                    We believe every developer deserves:
                </p>
                <ul className="mission-list">
                    <li>⭐ A chance to experience real interview pressure</li>
                    <li>⭐ Honest feedback and guided improvement</li>
                    <li>⭐ A platform built for practical learning</li>
                    <li>⭐ Fair access to high-quality interview prep</li>
                </ul>
                <p className="section-text">
                    Interview Buster isn't just a website — it's your **personal interview coach**.
                </p>
            </section>

            <section className="cta-section">
                <h2>Ready to crack your next interview?</h2>
                <button
                    className="cta-btn"
                    onClick={() => window.location.href = "/"}
                >
                    Start Preparation Now 🚀
                </button>
            </section>

        </div>
    );
}
